<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import { kilobytes } from '@/utils/formatter';
import bus from '@/utils/bus';
import settingsChart from '@/components/motlet/settings/chart';
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    // BEGIN::Removed.by.KWShin.2025.11.29.
    // title: String,
    // storeName: {
    //   type: String,
    //   required: true,
    // },
    // FINISH::Removed.by.KWShin.2025.11.29.
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      shape: 'circle',
      data: {
        value: '',
        type: 'digit',
      },
      // BEGIN::Added.by.KWShin.2025.11.29.
      chartFieldCode: 'rxBytes',
      // FINISH::Added.by.KWShin.2025.11.29.
    };
  },
  computed: {
    // BEGIN::Added.by.KWShin.2025.11.29.
    title() {
      const chartField = settingsChart['C_JAVA_OS_NTWK'].fields.find(f => f.code == this.chartFieldCode);
      return `${this.$t('dv.title.os.ntwk')} (${chartField.text})`;
    },
    isWs() {
      return this.descendants.find(d => d.active).supportWebService;
    },
    // FINISH::Added.by.KWShin.2025.11.29.
    // BEGIN::Removed.by.KWShin.2025.11.29.
    // descendants() {
    //   return this.$store.getters[`${this.storeName}/get`];
    // },
    // descendant() {
    //   return (this.descendants || []).find(d => d.active);
    // },
    // FINISH::Removed.by.KWShin.2025.11.29.
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  methods: {
    setData(data) {
      // BEGIN:Modified.by.KWShin.2025.11.29.
      // if (this.descendant.supportWebService) this.data.value = data.reduce((acc, item) => (acc += parseInt(item.rxPackets)), 0);
      if (data.length > 0) {
        let sum = 0;
        data.forEach(datum => {
          sum += parseInt(datum[this.chartFieldCode] || 0);
        });
        this.data.value = kilobytes(Math.ceil(sum / data.length));
      } else {
        this.data.value = '0 KB';
      }
      // FINISH:Modified.by.KWShin.2025.11.29.
    },
  },
  created() {
    // BEGIN::Added.by.KWShin.2025.11.29.
    // PcapNetwork.vue 컴포넌트의 모틀릿 Settings에서 차트항목 선택이 변화하면 버스를 통해 신호가 온다.
    bus.$on('update:chartFieldCode-dv/java/os/ntwk', chartFieldCode => {
      this.chartFieldCode = chartFieldCode;
    });
    // FINISH::Added.by.KWShin.2025.11.29.
  },
  destroyed() {
    // BEGIN::Added.by.KWShin.2025.11.29.
    bus.$off('update:chartFieldCode--dv/java/os/ntwk');
    // FINISH::Added.by.KWShin.2025.11.29.
  },
};
</script>
